import React from 'react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { getWeatherIconPlaceholder, getWeatherIconColor, weatherOptions, WeatherCondition } from '@/utils/weatherUtils';
import { cn } from '@/lib/utils';

interface WeatherIconButtonProps {
  value?: string;
  onChange: (value: WeatherCondition) => void;
  className?: string;
}


export const WeatherIconButton: React.FC<WeatherIconButtonProps> = ({
  value,
  onChange,
  className
}) => {
  const [open, setOpen] = React.useState(false);
  const IconComponent = getWeatherIconPlaceholder(value || 'sun');

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={cn("h-12 w-12 p-2", className)}
          aria-label="Selecionar condição climática"
        >
          <IconComponent className={cn("h-6 w-6", getWeatherIconColor(value || 'sun'))} />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-48 p-2">
        <div className="grid grid-cols-1 gap-1">
          {weatherOptions.map((option) => {
            const Icon = option.icon;
            return (
              <Button
                key={option.value}
                variant={value === option.value ? "default" : "ghost"}
                className="justify-start gap-2 h-10"
                onClick={() => {
                  onChange(option.value);
                  setOpen(false);
                }}
              >
                <Icon className={cn("h-4 w-4", getWeatherIconColor(option.value))} />
                <span className="text-sm">{option.label}</span>
              </Button>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
};